import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import { WindowWidthSensor } from 'libreact/lib/WindowWidthSensor'
import {
  Link,
  Route,
} from 'react-router-dom'
import Button from '../../Button'
import { LINKS } from '/'

const Container = styled.div`
  flex-shrink: 0;
`

const Step = styled.div`
  display: inline;
  font-weight: 600;
  padding-right: 3px;
  color: ${props => props.type === 'disabled' ? props.theme.colors.black : props.theme.colors.green};
`

const rootRoute = (location) => (
  _.take(location.pathname.split('/'), 2).join('/')
)

const isCompleted = (url, location) => (
  _.findIndex(LINKS, { url: rootRoute(location) }) > _.findIndex(LINKS, { url })
)

const status = (to, { match, location }) => {
  if (match) return 'active'
  if (isCompleted(to, location)) return 'completed'

  return 'disabled'
}

const padding = (small, mobile) => {
  if (mobile) return '10px 2px'
  if (small) return '10px'

  return '10px 20px'
}

export default ({ to, step, children, ...rest }) => (
  <Route path={to}>
    {(routeProps) => (
      <WindowWidthSensor>
        {({ width }) => {
          const small = width < 768
          const mobile = width < 500

          return (
            <Container>
              <Button
                as={Link}
                to={to}
                type={status(to, routeProps)}
                nav
                small
                padding={padding(small, mobile)}
                width={small ? 'inherit' : '150px'}
                {...rest}
              >
                <Step type={status(to, routeProps)}>
                  Step {step}{(!small || status(to, routeProps) === 'active') && ':'}
                </Step>
                {(!small || status(to, routeProps) === 'active') && children}
              </Button>
            </Container>
          )
        }}
      </WindowWidthSensor>
    )}
  </Route>
)
